import { useMemo } from 'react';
import UILink from 'UIComponents/link/UILink';
import FormattedPhoneNumber from 'I18n/components/FormattedPhoneNumber';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import CompanyName from './CompanyName';
import { getNavigateToContactRecord } from '../constants/events';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import RecordLink from 'crm-links/record/RecordLink';
import UsageTrackerContext from '../context/UsageTrackerContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledFormattedMessage = styled(FormattedMessage).withConfig({
  displayName: "ContactInformation__StyledFormattedMessage",
  componentId: "sc-1r6kszh-0"
})(["padding-left:4px;padding-right:4px;"]);
const StyledUIFlex = styled(UIFlex)(props => ({
  maxWidth: props.companyLink ? '' : '400px'
}));
const CompanyInformation = ({
  associatedCompanyId,
  companyName,
  companyLink,
  includeEschref
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StyledFormattedMessage, {
      message: "svh-workspace-ui-lib.ticket-header.fromLabel"
    }), /*#__PURE__*/_jsx(CompanyName, {
      associatedCompanyId: associatedCompanyId,
      companyName: companyName,
      companyLink: companyLink,
      includeEschref: includeEschref
    })]
  });
};
const isPhoneNumber = contactDetail => !isNaN(Number(contactDetail));
const ContactInformation = ({
  associatedCompanyId,
  companyName,
  contactDetail,
  contactLink,
  includeEschref,
  isKnownContact,
  companyLink,
  renderAssociateContactButton,
  vid,
  trackEvent,
  truncate,
  truncateStringProps
}) => {
  const ContactComponent = useMemo(() => {
    if (includeEschref) {
      return /*#__PURE__*/_jsx(RecordLink, {
        includeEschref: includeEschref,
        LinkComponentProps: {
          truncate,
          truncateStringProps,
          style: {
            width: 'max-content'
          }
        },
        objectId: vid,
        objectTypeId: "0-1",
        onTrackClick: () => trackEvent(getNavigateToContactRecord()),
        children: isPhoneNumber(contactDetail) ? /*#__PURE__*/_jsx(FormattedPhoneNumber, {
          value: contactDetail || ''
        }) : contactDetail
      });
    }
    return /*#__PURE__*/_jsx(UILink, {
      href: contactLink,
      external: true,
      onClick: () => trackEvent(getNavigateToContactRecord()),
      style: {
        width: 'max-content'
      },
      truncate: truncate,
      truncateStringProps: truncateStringProps,
      children: isPhoneNumber(contactDetail) ? /*#__PURE__*/_jsx(FormattedPhoneNumber, {
        value: contactDetail || ''
      }) : contactDetail
    });
  }, [contactDetail, contactLink, includeEschref, trackEvent, vid, truncate, truncateStringProps]);
  return /*#__PURE__*/_jsx(UsageTrackerContext.Provider, {
    value: trackEvent,
    children: /*#__PURE__*/_jsxs(UIFlex, {
      children: [/*#__PURE__*/_jsx(UIBox, {
        shrink: 0,
        "data-test-id": "ticket-header-contact-detail-link",
        children: isKnownContact ? ContactComponent : renderAssociateContactButton()
      }), /*#__PURE__*/_jsx(StyledUIFlex, {
        companyLink: companyLink,
        children: companyName ? /*#__PURE__*/_jsx(CompanyInformation, {
          associatedCompanyId: associatedCompanyId,
          includeEschref: includeEschref,
          companyName: companyName,
          companyLink: companyLink
        }) : null
      })]
    })
  });
};
ContactInformation.displayName = 'ContactInformation';
CompanyInformation.displayName = 'CompanyInformation';
export default ContactInformation;